import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Validators, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SelectedProviders, VerificationFormOptions } from '@core/models';

@Component({
    selector: 'app-verification-form',
    templateUrl: './verification-form.component.html',
    styleUrls: ['./verification-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VerificationFormComponent implements OnInit, AfterViewInit {
  static readonly componentName = 'VerificationFormComponent';
  
  @Input() isSubmitting = false;
  @Input() otpDest: string;  
  @Input() otpIsPhone: boolean;
  @Input() sysText: any;
  @Input() options: VerificationFormOptions;
  @Input() selectedProviders: SelectedProviders
  @Input() page: string;
  @Output() formSubmit = new EventEmitter<FormGroup>();
  @Output() sendCode = new EventEmitter<{provider: string, resend: boolean}>();
  @Output() goBack = new EventEmitter();
  @ViewChild('codeInput') codeInput: ElementRef<HTMLInputElement>;
  verificationForm: FormGroup;

  get code(): FormControl {
    return this.verificationForm.get('code') as FormControl;
  }

  get rememberMe(): FormControl {
    return this.verificationForm.get('rememberMe') as FormControl;
  }

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {    
    this.verificationForm = this.fb.group({
      code: [null, Validators.required],
      rememberMe: [false]
    })
  }

  ngAfterViewInit(): void {
    // this form replaces the sign-in form after a submit (or opens reset password), so focus
    // goes to its code field instead of being lost with the form it replaced
    setTimeout(() => this.codeInput?.nativeElement.focus());
  }

  onSubmit(): void {
    this.formSubmit.emit(this.verificationForm);
  }

  onResend(): void {    
    this.sendCode.emit({provider: this.otpIsPhone ? this.selectedProviders.phoneProvider : this.selectedProviders.emailProvider, resend: true});
  }

  onEmailCode(): void {    
    this.sendCode.emit({provider:this.selectedProviders.emailProvider, resend: true});
  }

  onGoBack(): void {
    this.goBack.emit();
  }
}